import type { FieldSchema } from "../../../schema-types"

export const SUPPORTED_PAGES = [
  'home', 'shop', 'product', 'category', 'categories', 'cart', 'checkout',
  'contact', 'signin', 'signup', 'account', 'wishlist', 'track-order',
  'order-success', 'privacy-policy', 'terms-of-service', 'shipping-policy',
  'return-policy', 'order-detail',
] as const

export const LINK_ITEM_SCHEMA: FieldSchema[] = [
  { key: 'id', label: 'ID', type: 'string' },
  { key: 'label', label: 'Label', type: 'string' },
  { key: 'href', label: 'Link', type: 'string' },
]

export const MEGA_MENU_SCHEMA: FieldSchema[] = [
  { key: 'id', label: 'ID', type: 'string' },
  { key: 'label', label: 'Label', type: 'string' },
  { key: 'href', label: 'Link URL', type: 'string' },
  {
    key: 'type',
    label: 'Type',
    type: 'select',
    options: [
      { label: 'Standard Link', value: 'link' },
      { label: 'Dropdown', value: 'dropdown' },
      { label: 'Mega Menu', value: 'mega-menu' },
    ],
  },
  {
    key: 'children',
    label: 'Dropdown Items',
    type: 'array',
    itemSchema: LINK_ITEM_SCHEMA,
    dependency: { field: 'type', value: 'dropdown' },
  },
  {
    key: 'columns',
    label: 'Mega Menu Columns',
    type: 'array',
    itemSchema: [
      { key: 'title', label: 'Column Title', type: 'string' },
      { key: 'items', label: 'Links', type: 'array', itemSchema: LINK_ITEM_SCHEMA },
    ],
    dependency: { field: 'type', value: 'mega-menu' },
  },
  {
    key: 'featuredImage',
    label: 'Featured Image',
    type: 'object',
    fields: [
      { key: 'src', label: 'Image', type: 'image' },
      { key: 'title', label: 'Title', type: 'string' },
      { key: 'href', label: 'Link', type: 'string' },
    ],
    dependency: { field: 'type', value: 'mega-menu' },
  },
]

export const SLIDE_SCHEMA: FieldSchema[] = [
  { key: 'title', label: 'Title', type: 'string' },
  { key: 'subtitle', label: 'Subtitle', type: 'text' },
  { key: 'image', label: 'Background Image', type: 'image' },
  { key: 'ctaText', label: 'Button Text', type: 'string' },
  { key: 'ctaLink', label: 'Button Link', type: 'string' },
  { key: 'badge', label: 'Badge Text', type: 'string' },
]

/** Spread into any schema's commonFields to give every section instance
 *  padding, background, visibility controls in the builder. */
/** Spacing and background the renderer applies around a section (visibility has its own switches in the editor). */
export const SECTION_STYLE_FIELDS: FieldSchema[] = [
  {
    key: 'styles.paddingTop',
    label: 'Padding Top',
    type: 'select',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Small', value: 'sm' },
      { label: 'Medium', value: 'md' },
      { label: 'Large', value: 'lg' },
      { label: 'Extra Large', value: 'xl' },
    ],
    default: 'md',
  },
  {
    key: 'styles.paddingBottom',
    label: 'Padding Bottom',
    type: 'select',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Small', value: 'sm' },
      { label: 'Medium', value: 'md' },
      { label: 'Large', value: 'lg' },
      { label: 'Extra Large', value: 'xl' },
    ],
    default: 'md',
  },
  {
    key: 'styles.background',
    label: 'Background',
    type: 'select',
    options: [
      { label: 'None (theme default)', value: 'default' },
      { label: 'Light grey', value: 'muted' },
      { label: 'Brand tint', value: 'primary' },
    ],
    default: 'default',
  },
]
